export const phydScoreLevel = {
  scoreA: 80,
  scoreB: 60,
};
